var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminShell',{attrs:{"page-title":_vm.pageTitle,"page-subtitle":_vm.pageSubtitle,"active-menu":"visits"}},[_c('StatsVisits',{attrs:{"base":_vm.baseUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }